export default __webpack_public_path__ + "static/media/stock.da303560.svg";